import { CertificateName } from 'interfaces';

interface CertificateRow {
  title: string;
  issuer: string;
  note?: string;
  warning?: string;
}
type CertificateRows = Record<string, CertificateRow>;

const compliance21: CertificateRows = {
  [CertificateName.Compliance21]: {
    title: 'Certificate of compliance – Type 2.1',
    issuer: 'Issued by Xometry.',
  },
};

const compliance22: CertificateRows = {
  [CertificateName.Compliance22]: {
    title: 'Certificate of compliance – Type 2.2',
    issuer: 'Issued by Xometry.',
  },
};

const origin: CertificateRows = {
  [CertificateName.Origin]: {
    title: 'Certificate of Origin',
    issuer: 'Issued by manufacturing partner.',
  },
};

const mat31: CertificateRows = {
  [CertificateName.Materials31]: {
    title: 'Raw material certificate (metals)',
    issuer: 'Issued by the material producer. To be requested from the Partner.',
  },
};

const mat31New: CertificateRows = {
  [CertificateName.Materials31v2]: {
    title: 'Raw material certificate – Type 3.1 (EN 10204)',
    issuer: 'Issued by the material producer. To be requested from the Partner.',
    warning: 'For customers needing a 3.1 EU certificate; order goes to European partners only',
  },
};

const plastic: CertificateRows = {
  [CertificateName.MaterialsPlastic]: {
    title: 'Raw material certificate (plastics)',
    issuer: 'Issued by the material producer. To be requested from the Partner.',
  },
};

const heatTreatment: CertificateRows = {
  [CertificateName.HeatTreatment]: {
    title: 'Heat treatment protocols',
    issuer: 'Issued by the Partner or their finishing subcontractor.',
  },
};

const Rohs: CertificateRows = {
  [CertificateName.Rohs]: {
    title: 'RoHS certificate',
    note: '(Restriction of Hazardous Substances)',
    issuer: 'Issued by Xometry, based on material certificates.',
  },
};

const Reach: CertificateRows = {
  [CertificateName.Reach]: {
    title: 'REACH certificate',
    note: '(Registration, Evaluation, Authorisation and Restriction of Chemicals)',
    issuer: 'Issued by Xometry.',
  },
};

export const certificateRows: CertificateRows = {
  ...compliance21,
  ...compliance22,
  ...mat31,
  ...mat31New,
  ...plastic,
  ...heatTreatment,
  ...origin,
  ...Rohs,
  ...Reach,
};
